import { httpService } from "../../base/services/httpService.service";

/**
 * GET /Workspaces/getPlanUsage — the organization's active workspaces (not
 * deleted, not archived), each with how many active projects it holds:
 * `{ workspaces: [{ id, name, projects }] }`. What the plan limits count, and
 * what the Subscription page checks a smaller plan against (planChanges.js).
 *
 * Resolves null when it can't be read: the server's own check then decides
 * (409 PLAN_LIMIT_EXCEEDED).
 */
export const readPlanUsage = () =>
   httpService
      .get("/Workspaces/getPlanUsage")
      .then((answer) => (Array.isArray(answer?.data?.workspaces) ? answer.data : null))
      .catch(() => null);
